import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js"

gsap.registerPlugin(ScrollTrigger)

let schematicImage = document.querySelector('.schematic__img');

if (schematicImage) {
  let schematicImageTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: schematicImage,
      start: "top 85%",
    }
  })

  schematicImageTimeline.fromTo(schematicImage, { opacity: 0 }, { opacity: 1 })
}
